module.exports = __webpack_public_path__ + "img/case9.8275dff0.png";